/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LastChatMessageResponseDto { 
    /**
     * Id сообщения
     */
    messageId: string;
    /**
     * Метка времени, взятая из MessageId
     */
    timestamp: number;
    /**
     * Время создания сообщения
     */
    createdAt: number;
    /**
     * Само сообщение
     */
    messageText: string;
    /**
     * ContentType сообщения
     */
    contentType: string | null;
    /**
     * Id автора сообщения
     */
    senderUserId: string;
    /**
     * Автор сообщения
     */
    senderUserName: string;
}

